import ApiService from '@/services/api.service.js';

export const GrantService = {

  all: function () {
    return ApiService.get('/grants');
  },

  get: function (id) {
    return ApiService.get('/grants/' + id);
  },

  getGrantRegions: function () {
    return ApiService.post('/grant-regions');
  },

  

}

export default GrantService